module.exports = __webpack_public_path__ + "img/pdd.8cd638b9.png";